import React, { useEffect, useState } from "react";
import { Card, Row, Col, Badge, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { CompanyService } from "Services/CompanyService";


const ViewSubscription = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [subscription, setSubscription] = useState<any>(null);

  const formatFeature = (feature: string) => {
    return feature.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString();
  };

  

  const getSubscriptionDetails = async () => {
    try {
      if (!id) return;

      const res = await CompanyService.getSubscriptionById(id);

      if (res.status === 200) {
        setSubscription(res.data.data);
      }
    } catch (error) {
      console.error("Unable to fetch subscription details", error);
    }
  };

  useEffect(() => {
    getSubscriptionDetails();
  }, []);

  if (!subscription) return null;

  return (
    <div className="company-page">
      <Card className="company-card shadow-lg border-0">
        <Card.Body>

          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold m-0">Subscription Details</h4>

            <Button variant="outline-secondary" onClick={() => navigate(-1)}>
              ← Back
            </Button>
          </div>

          {/* COMPANY DETAILS */}

          <Card className="mb-4 border-0 shadow-sm">
            <Card.Body>
              <h6 className="fw-bold mb-3">Company Information</h6>

              <Row>

                <Col md={4}>
                  <p>
                    <strong>Company Code :</strong>{" "}
                    {subscription.company?.company_code}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Name :</strong> {subscription.company?.name}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Status :</strong>

                    <Badge
                      bg={
                        subscription.company?.status === "active"
                          ? "success"
                          : "danger"
                      }
                      className="ms-2"
                    >
                      {subscription.company?.status}
                    </Badge>

                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Email :</strong> {subscription.company?.email}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Phone :</strong> {subscription.company?.phone}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Address :</strong> {subscription.company?.address}
                  </p>
                </Col>

              </Row>
            </Card.Body>
          </Card>

          {/* PLAN DETAILS */}

          <Card className="mb-4 border-0 shadow-sm">
            <Card.Body>

              <h6 className="fw-bold mb-3">Plan Information</h6>

              <Row>

                <Col md={4}>
                  <p>
                    <strong>Plan Name :</strong> {subscription.plan?.name}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Price :</strong> ₹{subscription.plan?.price}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Billing Cycle :</strong>{" "}
                    {subscription.plan?.billingCycle}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Currency :</strong> {subscription.plan?.currency}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Free Plan :</strong>{" "}
                    {subscription.plan?.isFree ? "Yes" : "No"}
                  </p>
                </Col>

              </Row>
            </Card.Body>
          </Card>

          {/* LIMITS */}

          <Card className="mb-4 border-0 shadow-sm">
            <Card.Body>

              <h6 className="fw-bold mb-3">Plan Limits</h6>

              <Row>

                {subscription.plan?.limits
                  ?.filter((limit: any) => limit.key !== "api_calls")
                  ?.map((limit: any, index: number) => (

                    <Col md={3} key={index}>

                      <Card className="text-center border">

                        <Card.Body>

                          <h6 className="text-muted">
                            {limit.key.replace("_", " ").toUpperCase()}
                          </h6>

                          <h4 className="fw-bold">{limit.value}</h4>

                        </Card.Body>

                      </Card>

                    </Col>

                  ))}

              </Row>

            </Card.Body>
          </Card>

          {/* FEATURES */}

          <Card className="border-0 shadow-sm">
            <Card.Body>

              <h6 className="fw-bold mb-3">AI Features</h6>

              {subscription.plan?.features?.map((feature: string, index: number) => (

                <Badge key={index} bg="primary" className="me-2 mb-2 p-2">
                  {formatFeature(feature)}
                </Badge>

              ))}

            </Card.Body>
          </Card>

          {/* SUBSCRIPTION INFO */}

          <Card className="mt-4 border-0 shadow-sm">
            <Card.Body>

              <h6 className="fw-bold mb-3">Subscription Info</h6>

              <Row>

                <Col md={4}>
                  <p>
                    <strong>Status :</strong>

                    <Badge
                      bg={
                        subscription.status === "active"
                          ? "success"
                          : "danger"
                      }
                      className="ms-2"
                    >
                      {subscription.status}
                    </Badge>

                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Start Date :</strong>{" "}
                    {formatDate(subscription.startDate)}
                  </p>
                </Col>

                <Col md={4}>
                  <p>
                    <strong>Expiry Date :</strong>{" "}
                    {formatDate(subscription.expiryDate)}
                  </p>
                </Col>

              </Row>

            </Card.Body>
          </Card>

        </Card.Body>
      </Card>
    </div>
  );
};

export default ViewSubscription;